<template>
  <vis-login-layout>
    <vis-loading size="md" v-if="loading" />
    <vis-error size="md" v-else-if="error" with-default :state="state" />
    <div v-else class="ba-w-full ba-flex ba-flex-wrap ba-justify-center ba-content-start">
      <div
        class="identity__tabs ba-w-full ba-text-xl md:ba-text-2xl ba-mb-8 xs:ba-mb-12 ba-text-center md:ba-w-full"
      >
        <span class="tabs-item tabs-item--active ba-mr-6">Вход</span>
        <router-link
          v-if="settings.canRegister"
          :to="{ name: 'register', query: { state } }"
          class="tabs-item hover:ba-no-underline"
          href="#"
        >Регистрация</router-link>
      </div>
      <p v-if="false" class="ba-text-center ba-text-sm ba-mb-5">
        <span v-if="settings.adminLogin">Вход для организаций</span>
        <span v-else>для физических лиц</span>
      </p>
      <div>
        <template v-if="settings.canExternalProviders">
          <form
            :action="getEsiaProviderUrl()"
            method="POST"
            enctype="application/x-www-form-urlencoded"
            class="ba-w-full ba-flex ba-flex-wrap ba-justify-center ba-max-w-xs ba-relative ba-pt-4"
          >
            <input type="hidden" name="state" :value="state" />
            <button type="submit" class="btn ba-border ba-w-full btn--provider">
              <img src="/img/esia-logo.svg" class="ba-pt-1 ba-mx-auto" />
            </button>
          </form>
          <p class="separator__login ba-mt-2">
            <span>или</span>
          </p>
        </template>
        <form
          @submit.prevent="loginFormSubmit"
          class="ba-w-full ba-flex ba-flex-wrap ba-justify-center ba-max-w-xs ba-relative ba-pt-4"
        >
          <p
            v-if="formError"
            class="error form-message ba-text-center ba-text-sm"
          >Введено неверное имя пользователя или пароль</p>
          <p
            v-if="formSuccess"
            class="success form-message ba-text-center ba-text-sm"
          >Вход выполнен успешно</p>
          <vis-form-input
            v-model="form.username"
            :disabled="formLoading"
            label="Имя пользователя"
            type="text"
            icon="fas fa-user"
            autocomplete="username email"
          />
          <vis-form-input
            v-model="form.password"
            :disabled="formLoading"
            label="Пароль"
            type="password"
            icon="fas fa-unlock-alt"
            autocomplete="current-password"
          />

          <p class="ba-w-full ba-my-5 ba-select-none input-wrap input-wrap--checkbox">
            <input id="checkbox" type="checkbox" v-model="form.rememberMe" :disabled="formLoading" />
            <label
              for="checkbox"
              class="ba-relative ba-flex ba-justify-start ba-mb-0 ba-leading-tight ba-cursor-pointer"
            >
              <span>Запомнить меня</span>
            </label>
          </p>
          <vis-captcha
            v-if="showCaptcha"
            :result.sync="captchResult"
            :refresh.sync="refreshCaptcha"
          />
          <button
            type="submit"
            :disabled="formLoading"
            class="btn ba-w-full ba-max-w-xs btn--login"
          >Войти</button>
        </form>
        <router-link
          v-if="settings.canRemember"
          :to="{ name: 'recovery', query: { state } }"
          class="forgot ba-block ba-text-center ba-w-full"
        >Забыли пароль?</router-link>
      </div>
      <a
        v-if="false"
        target="_blank"
        href="https://domain/privacy/privacy-policy"
        class="ba-w-full ba-block ba-text-center ba-text-sm ba-underline hover:ba-no-underline"
      >Политика конфиденциальности</a>
      <a
        v-if="false"
        target="_blank"
        href="https://domain/privacy/user-agreement"
        class="ba-w-full ba-block ba-text-center ba-text-sm ba-underline hover:ba-no-underline"
      >Пользовательское соглашение</a>
    </div>
  </vis-login-layout>
</template>

<script>
import VisLoginLayout from "./vis-login-layout";
import VisCaptcha from "./vis-captcha";
import { loginMixin } from "@ba/visary-account-common-vue";
import { createSettings } from "@/utils/settings";

export default {
  name: "vis-page-login",
  components: {
    VisLoginLayout,
    VisCaptcha
  },
  mixins: [loginMixin],
  data() {
    return {
      settings: createSettings()
    };
  },
  watch: {
    loginInfo() {
      this.settings = createSettings(this.loginInfo?.clientId);
    }
  }
};
</script>
